import * as React from "react";
import { Apps28Regular, Apps28Filled } from "@fluentui/react-icons";

import { TeamAppConfig } from "Apps/TeamAppModel";

const HelloWorldApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "HelloWorld" */ "./HelloWorldApp");
    return { default: namedExport.HelloWorldApp };
});

export const HelloWorld: TeamAppConfig = {
    title: "HelloWorld",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description: "HelloWorld is a template app for developers' reference.",
    team: "OSP",
    publicId: "Exchange\\OSP",
    owner: "OspOncall@microsoft.com",
    role: "*",
    tags: [],
    app: HelloWorldApp,
    path: "/HelloWorld"
};
